import { Progress } from '@metservicedev/met-ui';
import { LoginCallback } from '@okta/okta-react';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { MenuBar } from './components/MenuBar';
import { useAuth } from './context/AuthProvider';
import { Landing } from './pages/Landing';
import { ListVona } from './pages/ListVona';
import { createStyles } from './tss';

const useStyles = createStyles(({ theme }) => ({
  root: {
    background: (
      'url("/footer.svg") no-repeat bottom center, ' +
      `linear-gradient(${theme.color.bg.brand100} 0%, ${theme.color.bg.brand0} 100%)`
    ),
    minHeight: '100vh',
  },
}));

export const App: React.FC = () => {
  const { classes } = useStyles();
  const auth = useAuth();
  return (
    <main className={classes.root}>
      {auth.isAuthenticated && <MenuBar />}
      <Routes>
        <Route
          path="/login/callback"
          element={(
            <LoginCallback loadingElement={<Progress />} />
          )}
        />
        {auth.isAuthenticated ? (
          <>
            <Route path="/" element={<ListVona />} />
            <Route path="/edit/:volcanoNumber?" element={<ListVona edit />} />
          </>
        ) : (
          <Route path="/" element={<Landing />} />
        )}
        <Route path="*" element={<div data-testid="not-found">Not Found!</div>} />
      </Routes>
    </main>
  );
};
